import styled from '@emotion/styled';
import { scrollbarThin } from '~/shared/utils/styled';
import { breakpoints } from '~/theme';

export const StyledMenuContainerContent = styled.div(({ theme }) => ({
    display: 'grid',
    gap: theme.gridConfig.gap,
    [breakpoints.md]: {
        gridTemplateColumns: '1fr 5fr',
        gridAutoFlow: 'column',
    },
}));

export const StyledMenu = styled.div(({ theme }) => ({
    ...scrollbarThin,
    overflowX: 'auto',
    position: 'sticky',
    top: theme.spaces[6],
    backgroundColor: theme.colors.light,
    padding: `${theme.spaces[3]} 0 ${theme.spaces[2]}`,
    zIndex: theme.zIndices[1],
    [breakpoints.md]: {
        overflowX: 'unset',
        position: 'relative',
        minWidth: '275px',
        width: 'max-content',
        top: 0,
        borderRight: `1px solid ${theme.colors.light40}`,
        padding: `0 ${theme.spaces[4]} 0 0`,
    },
}));

export const StyledContent = styled.div();

export const StyledMenuList = styled.ul(({ theme }) => ({
    display: 'flex',
    gap: theme.spaces[4],

    [breakpoints.md]: {
        position: 'sticky',
        top: theme.spaces[10],
        flexDirection: 'column',
        gap: theme.spaces[1],
    },
}));

export const StyledMenuItem = styled.li(({ theme }) => ({
    display: 'flex',
    padding: `${theme.spaces[1]} 0`,
    whiteSpace: 'nowrap',
}));
